import { lazy, Suspense } from 'react';

const Confetti = lazy(() => import('react-confetti'));

export function LazyConfetti(props: any) {
  return (
    <Suspense fallback={null}>
      <Confetti {...props} />
    </Suspense>
  );
}
